module.exports = {
      id: "glyph:tick-usage",
      viewBox: "0 0 24 24",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#glyph:tick-usage",
      toString: function () {
        return this.url;
      }
    }